import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_504: DocMigration = {
  maxSchemaVersion: "0.0.504",
  description: "Level placement migration",
  apply(json: any): any {
    const { levels = {} } = json;

    // update placement method
    for (const levelId in levels) {
      const level = levels[levelId];
      if (level.datumUsage) {
        if (level.datumUsage.datumId === "stackedLevelDatum") {
          level.placement = {
            type: "STACKED",
            automaticStacking: true,
          };
        } else {
          level.placement = {
            type: "DATUM",
            datumUsage: level.datumUsage,
            aboveLevelId: level.aboveLevelId,
            belowLevelId: level.belowLevelId,
          };
        }

        delete level.datumUsage;
        delete level.aboveLevelId;
        delete level.belowLevelId;
      } else {
        level.placement = {
          type: "STACKED",
          automaticStacking: true,
        };
      }
    }

    return json;
  },
};

export default migration_0_0_504;
